import { saveAs } from 'file-saver/FileSaver'
import WorkOrder from './models/workOrder'
import router from '@/router'
import moment from 'moment'
import axios from 'axios'
import auth from '@/auth'
import Vue from 'vue'

export default {
  init() {
    axios.interceptors.response.use(r => r, error => {
      if (!error.response) {
        return Promise.reject(error)
      }

      if (error.response.config.ignoreErrors) {
        return Promise.reject(error)
      }

      const status = error.response.status
      if (status === 401) {
        auth.logOut()
        router.push({ name: 'Login' })
      } else if (status === 403) {
        Vue.prototype.$toastr('error', 'Acceso Denegado')
      } else if (status === 400 && error.response.data.message === 'error.validation') {
        Vue.prototype.$toastr('error', 'Error de validación')
      } else if (status === 400 && error.response.data.errorKey === 'nombreRepetido') {
        Vue.prototype.$toastr('error', 'El nombre de cliente ya está en uso, por favor indique otro')
      } else if (status === 400 && error.response.data.errorKey === 'codigoRepetido') {
        Vue.prototype.$toastr('error', 'El identificador de proyecto ya está en uso, por favor indique otro')
      } else if (status === 400 && error.response.data.errorKey === 'usuarioTienePartes') {
        Vue.prototype.$toastr('error', 'El operario tiene asociado partes y no es posible eliminarlo')
      } else if (status === 400 && error.response.data.errorKey === 'clientTieneProyectos') {
        Vue.prototype.$toastr('error', 'El cliente tiene proyectos vinculados y no es posible eliminarlo')
      } else if (status === 400 && error.response.data.errorKey === 'proyectoTienePartes') {
        Vue.prototype.$toastr('error', 'El proyecto tiene partes vinculados y no es posible eliminarlo')
      } else if (status === 400 && ((error.response.data.errorKey === 'userexists') || (error.response.data.errorKey === 'emailexists'))) {
        Vue.prototype.$toastr('error', 'Ya existe un usuario con ese correo electrónico')
      } else {
        Vue.prototype.$toastr('error', 'Error interno o de conexión')
      }

      return Promise.reject(error)
    })
  },
  setBaseURL(url) {
    axios.defaults.baseURL = url
  },
  setAuthHeader(token) {
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
  },
  authenticate(username, password) {
    return axios.post('authenticate', { username, password }).then(response => {
      this.setAuthHeader(response.data.id_token)
      return response.data.id_token
    })
  },
  workOrder: {
    delete(id) {
      return axios.delete(`work-orders/${id}`)
    },
    index(params = {}) {
      return this.requestPaginator('pending-first-validation-work-orders', params)
    },
    adminIndex(params = {}) {
      return this.requestPaginator('pending-second-validation-work-orders', params)
    },
    history(params = {}) {
      return this.requestPaginator('work-orders-historical', params)
    },
    requestPaginator(route, params = {}) {
      var config = {}
      config.headers = {}

      if (params['rangeIdDTO.initId'] != null) {
        config.headers.initId = params['rangeIdDTO.initId']
      }

      if (params['rangeIdDTO.endId'] != null) {
        config.headers.endId = params['rangeIdDTO.endId']
      }

      if (params.projectId != null) {
        config.headers.projectId = params.projectId
      }

      if (params.clientId != null) {
        config.headers.clientId = params.clientId
      }

      if (params.employeeId != null) {
        config.headers.employeeId = params.employeeId
      }

      if (params.validationStatus != null) {
        config.headers.validationStatus = params.validationStatus
      }

      if (params.workOrderTypeFilter != null) {
        config.headers.workOrderTypeFilter = params.workOrderTypeFilter
      }

      // Parseo de parámetros
      params = this.parseParams(params)

      if (params['rangeDateDTO.dateBefore'] != null) {
        config.headers.dateBefore = params['rangeDateDTO.dateBefore']
      }

      if (params['rangeDateDTO.dateAfter'] != null) {
        config.headers.dateAfter = params['rangeDateDTO.dateAfter']
      }

      if (params.lastModifiedDate != null && params.lastModifiedDate !== '') {
        config.headers.lastModifiedDate = params.lastModifiedDate
      }

      if (params.page != null) {
        config.headers.page = params.page
      }

      if (params.size != null) {
        config.headers.size = params.size
      }

      if (params.sort != null) {
        config.headers.sort = params.sort
      }

      return axios.get(route, config).then(response => {
        const paginator = response.data
        paginator.content = paginator.content.map(item => new WorkOrder(item))
        return paginator
      })
    },
    exportIndex(filters = {}) {
      // Filtro 1º validacion
      return axios.get('exportData-first-validation', {
        responseType: 'blob',
        params: this.parseParams(filters)
      }).then(response => { saveAs(response.data, 'partes.xlsx') })
    },
    exportAdmin(filters = {}) {
      // Filtro 2º validacion
      return axios.get('exportData-second-validation', {
        responseType: 'blob',
        params: this.parseParams(filters)
      }).then(response => { saveAs(response.data, 'partes.xlsx') })
    },
    exportHistory(filters = {}) {
      // Filtro Historico
      return axios.get('exportData', {
        responseType: 'blob',
        params: this.parseParams(filters)
      }).then(response => { saveAs(response.data, 'partes.xlsx') })
    },
    parseParams(filters) {
      const params = { ...filters }
      if (filters.lastModifiedDate) {
        params.lastModifiedDate = filters.lastModifiedDate && `${filters.lastModifiedDate}T00:00:00.000Z`
      }
      if (filters.from) {
        params['rangeDateDTO.dateAfter'] = filters.from + 'T00:00:00Z'
        delete params.from
      }
      if (filters.to) {
        params['rangeDateDTO.dateBefore'] = filters.to + 'T23:59:59Z'
        delete params.to
      }

      return params
    },
    async getPDF(id) {
      return axios.get(`work-order-adm-pdf/${id}`, { responseType: 'blob', ignoreErrors: true }).then(response => {
        return new Blob([response.data], { type: 'application/pdf' })
      })
    },
    async getVersions(id) {
      return axios.get(`work-order-versions/${id}`).then(response => response.data)
    },
    confirm(id) {
      return axios.put('validate-work-order/' + id)
    },
    modify(workOrder) {
      return axios.put('modify-work-order/', {
        ...workOrder,
        workOrderId: workOrder.id,
        workOrderDate: workOrder.workOrderDate && moment.utc(workOrder.workOrderDate).format()
      })
    },
    editValidationStatus(id, status) {
      return axios.put(`work-order-edit-status/${id}`, null, { params: { status } }).then(response => response.data)
    },
    projectOthersPartials(id, idProject, workOrderDate) {
      return axios.get('work-order-same-project/' + id + '?idProject=' + idProject + '&workOrderDate=' + workOrderDate).then(response => response.data)
    },
    userOthersPartials(id, idEmployee, workOrderDate) {
      return axios.get('work-order-same-worker/' + id + '?idEmployee=' + idEmployee + '&workOrderDate=' + workOrderDate).then(response => response.data)
    },
    changeProject(changeProjectParams) {
      return axios.put('change-work-order-project/', changeProjectParams)
    },
    timeRecords(params = {}) {
      var config = {}
      config.headers = {}

      if ((params.user != null) && (params.user.id != null)) {
        config.headers.idAppUser = params.user.id
      }

      if (params.from) {
        params['initDate'] = params.from + 'T00:00:00Z'
        delete params.from
      }
      if (params['initDate'] != null) {
        config.headers.initDate = params['initDate']
      }

      if (params.to) {
        params['endDate'] = params.to + 'T23:59:59Z'
        delete params.to
      }
      if (params['endDate'] != null) {
        config.headers.endDate = params['endDate']
      }

      if (params.page != null) {
        config.headers.pageNumber = params.page
      }

      if (params.size != null) {
        config.headers.pageSize = params.size
      }

      return axios.get('work-order-time-record', config).then(response => response.data)
    },
    exportTimeRecords(params = {}) {
      var config = {}
      config.responseType = 'blob'
      config.headers = {}

      if ((params.user != null) && (params.user.id != null)) {
        config.headers.idAppUser = params.user.id
      }

      if (params.from) {
        params['initDate'] = params.from + 'T00:00:00Z'
        delete params.from
      }
      if (params['initDate'] != null) {
        config.headers.initDate = params['initDate']
      }

      if (params.to) {
        params['endDate'] = params.to + 'T23:59:59Z'
        delete params.to
      }
      if (params['endDate'] != null) {
        config.headers.endDate = params['endDate']
      }

      return axios.get('work-order-time-record-export', config).then(response => { saveAs(response.data, 'registroLaboral.xlsx') })
    }
  },
  project: {
    index(params) {
      var config = {}
      config.headers = {}

      if (params.codeId != null) {
        config.headers.codeId = params.codeId
      }

      if (params.clientId != null) {
        config.headers.clientId = params.clientId
      }

      if (params.status != null) {
        config.headers.status = params.status
      }

      if (params.title != null) {
        config.headers.title = params.title
      }

      if (params.page != null) {
        config.headers.page = params.page
      }

      if (params.size != null) {
        config.headers.size = params.size
      }

      if (params.sort != null) {
        config.headers.sort = params.sort
      }

      return axios.get('projects-page', config).then(response => response.data)
    },
    create(params) {
      return axios.post('projects', params)
    },
    update(params) {
      return axios.put('projects', params)
    },
    delete(id) {
      return axios.delete(`projects/${id}`)
    }
  },
  client: {
    index(params) {
      var config = {}
      config.headers = {}

      if (params.codeId != null) {
        config.headers.codeId = params.codeId
      }

      if (params.name != null) {
        config.headers.name = params.name
      }

      if (params.status != null) {
        config.headers.status = params.status
      }

      if (params.page != null) {
        config.headers.page = params.page
      }

      if (params.size != null) {
        config.headers.size = params.size
      }

      if (params.sort != null) {
        config.headers.sort = params.sort
      }

      return axios.get('clients', config).then(response => response.data)
    },
    create(params) {
      return axios.post('clients', params)
    },
    update(params) {
      return axios.put('clients', params)
    },
    delete(id) {
      return axios.delete(`clients/${id}`)
    }
  },
  appUser: {
    currentUser() {
      return axios.get('logged-app-user')
    },
    index(params = {}) {
      var config = {}
      config.headers = {}

      if (params.name != null) {
        config.headers.name = params.name
      }

      if (params.status != null) {
        config.headers.status = params.status
      }

      if (params.page != null) {
        config.headers.page = params.page
      }

      if (params.size != null) {
        config.headers.size = params.size
      }

      if (params.sort != null) {
        config.headers.sort = params.sort
      }

      return axios.get('app-users', config).then(response => response.data)
    },
    create(params) {
      return axios.post('app-users', params)
    },
    update(params) {
      return axios.put('app-users', params)
    },
    delete(id) {
      return axios.delete(`app-users/${id}`)
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/api.js